/**
 * Address validations
 *
 * Validation schemas for address information: street, district, city, postal code, etc.
 */
import { z } from "zod";
import { t, createValidator } from "./utils";
/**
 * Street validation schema factory
 */
export const streetSchema = () => {
    return z.string().min(1, { message: t("required") });
};
/**
 * Building number validation schema factory
 */
export const buildingNumberSchema = () => {
    return z.string().min(1, { message: t("required") });
};
/**
 * Interior number validation schema factory (optional)
 */
export const interiorNumberSchema = () => {
    return z.string().optional();
};
/**
 * District/colony validation schema factory
 */
export const districtSchema = () => {
    return z.string().min(1, { message: t("required") });
};
/**
 * City validation schema factory
 */
export const citySchema = () => {
    return z.string().min(1, { message: t("required") });
};
/**
 * State validation schema factory
 */
export const stateSchema = () => {
    return z.string().min(1, { message: t("required") });
};
/**
 * Postal code validation schema factory
 */
export const postalCodeSchema = () => {
    return z
        .string()
        .min(1, { message: t("required") })
        .regex(/^\d{5}$/, { message: t("postalCode.invalid") });
};
/**
 * Place ID validation schema factory (optional)
 */
export const placeIdSchema = () => {
    return z.string().nullable().optional();
};
// Validator functions
export const validateStreet = createValidator(streetSchema);
export const validateBuildingNumber = createValidator(buildingNumberSchema);
export const validateInteriorNumber = createValidator(interiorNumberSchema);
export const validateDistrict = createValidator(districtSchema);
export const validateCity = createValidator(citySchema);
export const validateState = createValidator(stateSchema);
export const validatePostalCode = createValidator(postalCodeSchema);
export const validatePlaceId = createValidator(placeIdSchema);
